import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2081c373"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "login-page flex-center"
};
const _hoisted_2 = {
  class: "login-panel flex box-sizing"
};
const _hoisted_3 = {
  class: "login-action flex-full box-sizing"
};
const _hoisted_4 = {
  class: "tabs"
};
const _hoisted_5 = {
  class: "content"
};
import { ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import panelCompany from './components/panel-company.vue';
import accoutAction from './components/accout-action.vue';
import phoneAction from './components/phone-action.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'login',
  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    const tabsActive = ref('accout');
    onMounted(() => {
      document.title = '登录';
    });
    return (_ctx, _cache) => {
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");
      const _component_el_tabs = _resolveComponent("el-tabs");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(panelCompany), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_tabs, {
        modelValue: tabsActive.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => tabsActive.value = $event),
        class: "demo-tabs"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
          label: "账号密码登录",
          name: "accout"
        })]),
        _: 1
      }, 8, ["modelValue"]), _createElementVNode("div", _hoisted_5, [tabsActive.value === 'phone' ? (_openBlock(), _createBlock(phoneAction, {
        key: 0
      })) : _createCommentVNode("", true), tabsActive.value === 'accout' ? (_openBlock(), _createBlock(accoutAction, {
        key: 1
      })) : _createCommentVNode("", true)])])])])]);
    };
  }
});